





import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {ActiveProvide} from "@/support/reactive"

/**
 * @status stable
 * @published 4.0.0
 * @changelog 4.0.0 Published.
 */
@Component({ inject: [] })
export default class JdsLocaleProvider extends Vue {
    @ActiveProvide('jds.locale') localeProvider = 'en-GB';

    @Prop({default: 'en-GB'}) locale!: string;

    @Watch('locale', {immediate: true})
    syncProvide () {
        this.localeProvider = this.locale;
    }
}
